import { Observable, map } from "rxjs";
import { ICodeNameDto } from "../../../interface/dto/code-name.dto";
import { IListItem } from "../../../interface/list-item";
import { get } from "../../../service/api";
import { ITokenPair } from "../../auth/interface/dto/token-pair";

const fromDtoCountriesMapper = (dtos: Array<ICodeNameDto>): Array<IListItem> =>
    dtos.length
        ? dtos.map((item) => ({
              id: item.code,
              name: item.name,
          }))
        : [];

export const getCountries = (
    tokens: ITokenPair,
): Observable<Array<IListItem>> =>
    get<Array<ICodeNameDto>>("/common/countries", undefined, tokens).pipe(
        map((dto) => fromDtoCountriesMapper(dto)),
    );
